import { getCssVarHex } from "src/utility";
import i18n from "src/i18n";

export const COLORS = {
  SUCCESS_GREEN: getCssVarHex("--color-font-success"),
  WARNING_YELLOW: getCssVarHex("--color-font-warning"),
  FAIL_RED: getCssVarHex("--color-font-danger"),
};

export enum OrderStatus {
  Success = 1,
  Failed = 2,
  Pending = 3,
  Canceled = 4,
  Booked = 5,
  Ticketed = 6,
  Confirmed = 7,
}

export const STATUS_MAP = {
  [OrderStatus.Success]: { get label() { return i18n.t("UserHistory.common.success"); },   color: COLORS.SUCCESS_GREEN },
  [OrderStatus.Failed]: { get label() { return i18n.t("UserHistory.common.failed"); },    color: COLORS.FAIL_RED },
  [OrderStatus.Pending]: { get label() { return i18n.t("UserHistory.common.pending"); },   color: COLORS.WARNING_YELLOW },
  [OrderStatus.Canceled]: { get label() { return i18n.t("UserHistory.common.canceled"); },  color: COLORS.FAIL_RED },
  [OrderStatus.Booked]: { get label() { return i18n.t("UserHistory.common.booked"); },    color: COLORS.SUCCESS_GREEN },
  [OrderStatus.Ticketed]: { get label() { return i18n.t("UserHistory.common.ticketed"); },  color: COLORS.SUCCESS_GREEN },
  [OrderStatus.Confirmed]: { get label() { return i18n.t("UserHistory.common.confirmed"); }, color: COLORS.SUCCESS_GREEN },
};
